import { render } from "./HomeServices.vue?vue&type=template&id=aab50a82&scoped=true"
import script from "./HomeServices.vue?vue&type=script&lang=js"
export * from "./HomeServices.vue?vue&type=script&lang=js"

import "./HomeServices.vue?vue&type=style&index=0&id=aab50a82&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aab50a82"]])

export default __exports__